import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Card, CardBody, Col } from "reactstrap";
import { HelperCards } from "../../../../Constant";
import { HELPER_DATA } from "../../../../Data/UiKit/Dropdown";
import { HelperCart } from "./HelperCard/HelperCard";
import { WarningCard } from "./WarningCard/WarningCard";
import { AlertCard } from "./AlertCard/AlertCard";

const HelperCard = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={HelperCards} span={HELPER_DATA} />
        <CardBody className="dropdown-basic m-0">
          <div className="common-flex">
            <HelperCart />
            <WarningCard />
            <AlertCard />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default HelperCard;
